import React from "react";
import SummaryDetailsCard from "../../../../../../components/Summary/SummaryDetailsCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Details container for the foodie shift summary. Shows the shift name.
 * Thin wrapper over the shared SummaryDetailsCard.
 */
const SummaryContainerDetails = ({ data, t }) => {

    const items = [
        {
            label: 'name',
            value: data?.name
        }
    ];

    return <SummaryDetailsCard items={items} t={t} className={'d-block'}/>;

}

export default SummaryContainerDetails
